;(function () {
    var commonSwiper = new Swiper('.solution-common-swiper-container',{
        observer:true,
        observeParents:true,
        autoplay: true,
        pagination:{
            el:'.solution-common-swiper-pagination'
        },
        // 左右切换
        navigation: {
            nextEl: '.solution-common-swiper-button-next',
            prevEl: '.solution-common-swiper-button-prev',
        },
        on: {
            //简体翻页事件
            slideChangeTransitionStart:function () {
                var videoContentELs = document.querySelectorAll('.common-swiper-content-video');
                videoContentELs.forEach(function (vidoeItem) {
                    vidoeItem.querySelector('video').classList.add('hide');
                    vidoeItem.querySelector('video').pause();
                    vidoeItem.querySelector('img').classList.remove('hide');
                    vidoeItem.querySelector('.play-video-icon').classList.remove('hide');
                    $('.solution-common-swiper-pagination').show();
                    commonSwiper.autoplay.start();
                });
            }
        }
    })

    //视频
    var videoContentEls = document.querySelectorAll('.common-swiper-content-video');
    if(videoContentEls.length > 0){
        videoContentEls.forEach(function (item) {
            item.addEventListener('click', function (e) {
                e.currentTarget.querySelector('video').classList.remove('hide');
                e.currentTarget.querySelector('video').play();
                e.currentTarget.querySelector('img').classList.add('hide');
                e.currentTarget.querySelector('.play-video-icon').classList.add('hide');
                $('.solution-common-swiper-pagination').hide();
                commonSwiper.autoplay.stop();
            });
        });
    }

    var backCommonSwiper = new Swiper('.common-back-swiper-container',{
        loop: true,
        observer:true,
        observeParents:true,
        autoplay: true,
        disableOnInteraction: false,
        pagination:{
            el: '.back-common-swiper-pagination',
            clickable: true
        }
    });
})();